import React, { useState, useEffect } from 'react';
import { useOrg } from '../../hooks/useOrg';
import { surfaceTypeService } from '../../services/surfaceTypeService';
import { useNotifications } from '../NotificationSystem';
import authService from '../../services/authService';
import './SurfaceTypesManager.css';

const SurfaceTypesManager = () => {
  const { activeOrgId } = useOrg();
  const { notify } = useNotifications();
  const [surfaces, setSurfaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState('');
  const [newCode, setNewCode] = useState('');

  const currentUser = authService.getCurrentUser();

  const load = async () => {
    if (!activeOrgId) return;
    setLoading(true);
    try {
      let list = await surfaceTypeService.getAllSurfaceTypes(activeOrgId);
      if (list.length === 0) {
        await surfaceTypeService.seedSurfaceTypes(activeOrgId, currentUser?.uid);
        list = await surfaceTypeService.getAllSurfaceTypes(activeOrgId);
      }
      setSurfaces(list);
    } catch (err) {
      notify.error(err.message || String(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrgId]);

  const handleAdd = async () => {
    if (!newName.trim()) {
      notify.error('Numele este obligatoriu');
      return;
    }
    if (!activeOrgId) return;
    try {
      await surfaceTypeService.createSurfaceType(activeOrgId, {
        name: newName.trim(),
        code: newCode.trim(),
        sort_order: surfaces.length + 1
      }, currentUser?.uid);
      setNewName('');
      setNewCode('');
      notify.success('Tip suprafață adăugat');
      await load();
    } catch (err) {
      notify.error(err.message || String(err));
    }
  };

  const handleDeactivate = async (id) => {
    try {
      await surfaceTypeService.deactivateSurfaceType(id, currentUser?.uid);
      notify.success('Tip suprafață dezactivat');
      await load();
    } catch (err) {
      notify.error(err.message || String(err));
    }
  };

  const active = surfaces.filter((s) => s.is_active);
  const inactive = surfaces.filter((s) => !s.is_active);

  return (
    <div className="settings-section surface-types-manager">
      <h3>Tipuri Suprafețe</h3>
      <p className="section-desc">Nomenclator utilizat în înregistrările ATP și cererile de laborator.</p>

      {loading ? <div>Se încarcă...</div> : (
        <>
          <div className="surface-types-table-wrap">
            {active.map((s) => (
              <div key={s.id} className="surface-types-row">
                <span className="item-name">{s.name}</span>
                <span className="item-code">{s.code || '—'}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-secondary btn-deactivate"
                  onClick={() => handleDeactivate(s.id)}
                >
                  Dezactivează
                </button>
              </div>
            ))}
          </div>

          {inactive.length > 0 && (
            <details className="surface-types-inactive">
              <summary>Inactive ({inactive.length})</summary>
              {inactive.map((s) => (
                <div key={s.id} className="surface-types-row">
                  <span className="item-name">{s.name}</span>
                  <span className="item-code">{s.code || '—'}</span>
                  <span />
                </div>
              ))}
            </details>
          )}

          <div className="surface-types-add">
            <h4>Adaugă tip nou</h4>
            <div className="add-form-row">
              <input
                type="text"
                placeholder="Nume suprafață *"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
              />
              <input
                type="text"
                className="code-field"
                placeholder="Cod (opțional)"
                value={newCode}
                onChange={(e) => setNewCode(e.target.value)}
              />
              <button type="button" className="btn btn-primary btn-sm" onClick={handleAdd}>
                Adaugă
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SurfaceTypesManager;
